import { useTranslation } from 'react-i18next';

import { ReactComponent as RightArrowIcon } from '../../../../../../assets/icons/arrow-right.svg';
import Badge from '../../../../../../shared/components/Globals/Badge/Badge';
import { PROSPECT_STATUS_BADGE_VARIANT, PROSPECT_STATUS_LABEL } from '../../../../../../shared/constants/prospects';
import { CLICK_ACTION, VIEW_FULL_PROFILE } from '../../../../../../shared/constants/tagManager';
import type { IProspect } from '../../../../../../shared/interfaces/prospects';
import TagManagerService from '../../../../../../shared/services/gtm/tagManagerService';
import { TRANSLATIONS_PROSPECTS } from '../../../../../../shared/translations/prospects';
import type { ProspectStatus } from '../../../../../../shared/types/prospects';
import './ProspectDetailHeader.scss';

interface IProspectDetailHeaderProps {
  prospect: IProspect;
  isLoading?: boolean;
  onViewProfile: (id: number) => void;
}

const ProspectDetailHeader = ({ prospect, isLoading = false, onViewProfile }: IProspectDetailHeaderProps) => {
  const { t } = useTranslation();
  const status = prospect.status in PROSPECT_STATUS_LABEL ? (prospect.status as ProspectStatus) : 'pending_quote';

  if (isLoading) {
    return (
      <div className="prospect-detail-header">
        <div className="prospect-detail-header__row">
          <span
            className="prospect-detail-header__skeleton prospect-detail-header__skeleton--name"
            aria-hidden="true"
          />
          <span
            className="prospect-detail-header__skeleton prospect-detail-header__skeleton--badge"
            aria-hidden="true"
          />
        </div>
        <span className="prospect-detail-header__skeleton prospect-detail-header__skeleton--link" aria-hidden="true" />
      </div>
    );
  }

  const handleViewProfileClick = () => {
    TagManagerService.pushEvent(CLICK_ACTION, VIEW_FULL_PROFILE);
    onViewProfile(prospect.id);
  };

  return (
    <div className="prospect-detail-header">
      <div className="prospect-detail-header__row">
        <h2 className="prospect-detail-header__name">{prospect.companyName}</h2>
        <Badge variant={PROSPECT_STATUS_BADGE_VARIANT[status]}>{t(PROSPECT_STATUS_LABEL[status])}</Badge>
      </div>
      <button type="button" className="prospect-detail-header__link" onClick={handleViewProfileClick}>
        {t(TRANSLATIONS_PROSPECTS.detail.viewFullProfile)}
        <RightArrowIcon className="prospect-detail-header__link-icon" />
      </button>
    </div>
  );
};

export default ProspectDetailHeader;
